// Clickable
$(function () {
    $('.clickable').each(function(){
        var $this = $(this),
            imgLink = $this.find('a img'),
            down,
            up,
            link = $this.find('a').first(),
            auxClick;

        if (imgLink.length) {
            imgLink.unwrap();
        }

        $this.on('mousedown', function(e) {
            down = + new Date();
            auxClick = false;

            if (e.which === 3) {
                auxClick = true;
            }
        }).on('mouseup', function() {
            up = +new Date();

            if ((up - down) < 200 && auxClick === false) {
                link[0].click();
            }
        });
    });
});